import { Modal, ModalContent } from '@restworld/ui-ds-base';

export interface ModalWrapperProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showBackButton?: boolean;
  onBack?: () => void;
  // Fixed header/footer slots: pass these so ModalContent pins them in place and
  // only the middle content scrolls.
  title?: React.ReactNode;
  footer?: React.ReactNode;
}

export const ModalWrapper = ({ open, onClose, children, showBackButton, onBack, title, footer }: ModalWrapperProps) => {
  return (
    <Modal open={open} onOpenChange={(v) => !v && onClose()}>
      <ModalContent
        className="lg:min-w-[31.75rem] lg:max-w-[31.75rem]"
        showBackButton={showBackButton}
        onBack={onBack}
        title={title}
        footer={footer}
      >
        {children}
      </ModalContent>
    </Modal>
  );
};
